import { RootState } from "../store";

export const selectRectification = (state: RootState) => state.rectification;

export const selectRequestMoreInfo = (state: RootState) => state.rectification.requestMoreInfo;

export const selectEvidenceLoading = (state: RootState) => state.rectification.evidenceLoading;

export const selectShowEvidenceDialog = (state: RootState) => state.rectification.showEvidenceDialog;

export const selectHasEvidence = (state: RootState) => state.rectification.hasEvidence;